import React from 'react';
import { businessHours, DayHours } from '../data/hours';
import { MapPin, Clock } from 'lucide-react';

const SHOP_LOCATION = {
  lat: 51.5047,
  lng: -0.2264,
  address: '272 Uxbridge Road, W12 7JA',
  city: 'Shepherd\'s Bush',
  postcode: 'London',
  phone: '+442012345678',
  email: 'info@3dbarbers.com'
};

const BusinessHours: React.FC<{ hours: DayHours[] }> = ({ hours }) => {
  const today = new Date().getDay();
  // Convert from JS day (0 = Sunday) to our array (0 = Monday)
  const todayIndex = today === 0 ? 6 : today - 1;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg">
      <div className="flex items-center mb-4">
        <Clock className="h-5 w-5 text-amber-500 mr-2" />
        <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100">Business Hours</h3>
      </div>
      <div className="">
        {hours.map((dayHour, index) => (
          <div 
            key={dayHour.day} 
            className={`flex justify-between ${index === todayIndex ? 'text-amber-600 dark:text-amber-500 font-medium' : 'bg-white dark:bg-gray-800'}`}
          >
            <span>{dayHour.day}</span>
            <span>{dayHour.hours}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const FindUsSection: React.FC = () => {
  return (
    <section id="find-us" className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-gray-100 mb-4 font-['Instrument_Serif']">Find Us</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
          <p className="text-gray-700 dark:text-gray-300 text-xl md:text-2xl mx-auto font-['Instrument_Serif']">
            Conveniently located in the heart of Shepherd's Bush. Stop by for a cut or book an appointment today.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 bg-gray-700 rounded-xl overflow-hidden shadow-lg h-[400px]">
            <img
              src="/assets/shop.webp"
              alt="Inside 3D Afro & Euro Unisex Salon"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="space-y-6">
            <div className="bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 rounded-xl p-6 shadow-lg">
              <div className="flex items-center mb-4">
                <MapPin className="h-5 w-5 text-amber-500 mr-2" />
                <h3 className="text-xl font-semibold">Our Location</h3>
              </div>
              <p className="text-gray-800 dark:text-gray-100">
                {SHOP_LOCATION.address}<br />
                {SHOP_LOCATION.city}<br />
                {SHOP_LOCATION.postcode}
              </p>
              <a
                href="https://maps.app.goo.gl/Z3UB9pQbqKZv3p3a7"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center justify-center px-4 py-2 bg-amber-500 hover:bg-amber-600 text-gray-900 font-semibold rounded-full transition-all duration-300 hover:shadow-lg hover:scale-105"
              >
                Find Directions
              </a>
            </div>
            
            <BusinessHours hours={businessHours} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FindUsSection;